import PreferencesManager from "../../../components/sharedcomponents/preferenceManager";
import "../userDashboard.css";

export const UserPreferencePageCategory = () => {
  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <PreferencesManager
          showBackButton
          backButtonLink={"/users/"}
          displayMode="separate"
          activeIndex="categories"
          afterSaveRedirect={"/users/preference-tag"}
        ></PreferencesManager>
      </div>
    </>
  );
};

export default UserPreferencePageCategory;
